import { Box, Stack, Typography } from "@mui/material";
import React from "react";

const DashboardStatsBox = ({
  value,
  valueComponent,
  title,
  valueColor,
  desc,
}) => {
  return (
    <Stack
      sx={{
        gap: 1,
        padding: 1,
        minWidth: { xs: "40%", md: "40%", lg: "20%" },
        maxWidth: { xs: "40%", md: "40%", lg: "20%" },
        flexDirection: "row",
        borderRadius: "8px",
        boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.22)",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: { md: "50px", xs: "30px" },
          height: { md: "50px", xs: "30px" },
          aspectRatio: 1,
          //   padding: 2.5,
          borderRadius: "6px",
          backgroundColor: valueColor,
        }}
      >
        {!valueComponent && (
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: { md: "20px", md: "16px", xs: "12px" },
              color: "#09101D",
            }}
          >
            {value}
          </Typography>
        )}
        {valueComponent}
      </Box>

      <Stack
        sx={{
          flex: 1,
          gap: 0,
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <Typography
          sx={{ fontSize: { xs: "10px", md: "16px" }, fontWeight: "600" }}
        >
          {title}
        </Typography>
        <Typography sx={{ fontSize: { xs: "8px", md: "10px" } }}>
          {desc}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default DashboardStatsBox;
